import { AdviceMediaDataType } from 'constants/mediaData'

export const MediaFindFilter = (medias: AdviceMediaDataType[], mediaId: string): AdviceMediaDataType | undefined => {
  return medias.find((c) => c.uid === mediaId)
}
